module.exports = __webpack_public_path__ + "img/debod.50f909ea.png";